import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  notification: BehaviorSubject<string> = new BehaviorSubject<string>('')
  constructor() { }
  setNotification(error: string) {
    this.notification.next(error)
  }
  getNotification() {
    return this.notification
  }
}
